export default __webpack_public_path__ + "static/media/No campaigns.880a2419.svg";